import { type Moment, moment } from "@msuite/utils/date";
import { useState } from "react";

interface UseCalendarControlsProps {
	scope: moment.unitOfTime.DurationConstructor;
	default?: Moment;
}

export function useCalendarControls(
	props: UseCalendarControlsProps = {
		scope: "year",
		default: moment(),
	},
) {
	/** State */
	const [current, setCurrent] = useState<Moment>(props.default || moment());

	/** Functions */
	function handleOnGoBack() {
		const newCurrent = current.clone().subtract(1, props.scope);
		setCurrent(newCurrent);
	}

	function handleOnGoForward() {
		const newCurrent = current.clone().add(1, props.scope);
		setCurrent(newCurrent);
	}

	return {
		current,
		setCurrent,
		handleOnGoBack,
		handleOnGoForward,
	};
}

export type CalendarControls = ReturnType<typeof useCalendarControls>;
